import { render, staticRenderFns } from "./BoisType.vue?vue&type=template&id=0cf45fac&"
import script from "./BoisType.vue?vue&type=script&lang=ts&"
export * from "./BoisType.vue?vue&type=script&lang=ts&"
import style0 from "./BoisType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports